package br.com.texeratx.boardgametimeapp.core.active_match

import kotlinx.serialization.Serializable

/**
 * Tudo que precisamos para "reviver" a partida ativa após fechar/reabrir o app.
 */
@Serializable
data class ActiveMatchSnapshot(
    val match: ActiveMatch,
    val status: ActiveMatchStatus,
    val pausedAtEpochMillis: Long? = null,
    val accumulatedPausedMillis: Long = 0L
)
